import log from 'salvo-lite/log'
import axios from 'axios'

class SelectAjaxReplace {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._data = JSON.parse(this._elem.dataset.selectAjaxReplace)
    }

    onInit () {
        this._elem.addEventListener('change', async e => {
            log.debug('SelectURL', 'Change event', this)
            for (let obj of this._data) {
                let elem = document.querySelector(obj.toReplace)
                if (elem) {
                    elem.classList.add('loading')
                }
            }
            let resp = await axios.get(this._elem.value)
            let parser = new DOMParser()
            let html = parser.parseFromString(resp.data, 'text/html')
            for (let obj of this._data) {
                let fetchedElem = html.querySelector(obj.toFetch)
                let elem = document.querySelector(obj.toReplace)
                if (elem) {
                    elem.innerHTML = fetchedElem.innerHTML
                    elem.classList.remove('loading')
                    window.dispatchEvent(new Event('load'))
                    this._theme.registerComponents(elem)
                    document.dispatchEvent(new Event('preload-update'))
                    this.updateHistoryState(this._elem.value)
                }
            }
        })
    }

    updateHistoryState (url) {
        if (!history.replaceState || !url) {
            return
        }

        let newurl = window.location.protocol + '//' + window.location.host + url
        window.history.replaceState({ path: newurl }, '', newurl)
    }
}

export default SelectAjaxReplace



// WEBPACK FOOTER //
// ./src/resources/scripts/components/SelectAjaxReplace.js